export default function () {
    $(function () {
        const autoSubmit = $('#auto-submit').val();
        if (autoSubmit === "1") {
            // The name/value of the submit button is needed, see https://stackoverflow.com/a/23199267/94289
            document.getElementById('set').click();
        }
    });
}